import { Grid, Typography, makeStyles, } from '@material-ui/core';
import React, { useContext } from 'react';
import StoryContext from '../../contexts/StoryContext';
import MessageBox from '../MessageBox';
import SubquestionBox from '../SubquestionBox';
// import AveragePrice from './AveragePrice';
import Access from './Access';
import AccessByChildAge from './AccessByChildAge';
import AccessByQualityRating from './AccessByQualityRating';
import AccessBySettingType from './AccessBySettingType';
import ErrorBoundary from '../ErrorBoundary';

function Q1Row2() {
  const { lightColor, darkColor } = useContext(StoryContext);

  const classes = makeStyles((theme) => ({
    title: {
      color: `${darkColor} !important`,
      textTransform: 'capitalize',
    },
  }))();

  return (
    <SubquestionBox color={lightColor}>
      <Grid
        spacing={2}
        container
        direction="row"
        justify="center"
        alignItems="center"
      >
        <Grid item xs={12}>
          <Typography variant="h4" component="h3" align="center" className={classes.title} gutterBottom>
            Access to child care slots
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
          >
            <Grid item xs={10} sm={6}>
              <MessageBox>
                <ErrorBoundary>
                  <Access />
                </ErrorBoundary>
              </MessageBox>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={4} align="center">
          <ErrorBoundary>
            <AccessBySettingType height={200} />
          </ErrorBoundary>
        </Grid>
        <Grid item xs={12} sm={4} align="center">
          <ErrorBoundary>
            <AccessByChildAge height={200} />
          </ErrorBoundary>
        </Grid>
        <Grid item xs={12} sm={4} align="center">
          <ErrorBoundary>
            <AccessByQualityRating height={200} />
          </ErrorBoundary>
        </Grid>
      </Grid>
    </SubquestionBox>
  );
}

export default Q1Row2;
